class ProductElite {
  constructor(root) {
    this.root = root;
    this.product = window.__PRODUCT__;

    this.variantInput = root.querySelector('[data-variant-input]');
    this.priceEl = root.querySelector('[data-price]');
    this.atcBtn = root.querySelector('[data-atc]');
    this.sizeBtns = root.querySelectorAll('.p-product__size');
    this.mainImage = root.querySelector('.p-product__image');
    this.selectedText = root.querySelector('[data-selected-size]');

    this.cartDrawer = document.querySelector('[data-cart-drawer]');
    this.cartContent = document.querySelector('[data-cart-items]');
    this.closeCartBtn = document.querySelector('[data-close-cart]');

    this.currentVariant = this.product.variants[0];

    this.init();
  }

  init() {
    this.bindSizes();
    this.bindGallery();
    this.bindATC();
    this.bindCartDrawer();
  }

  bindSizes() {
    this.sizeBtns.forEach(btn=>{
      btn.addEventListener('click',()=>{
        if(btn.disabled) return;

        this.sizeBtns.forEach(b=>b.classList.remove('p-product__size--active'));
        btn.classList.add('p-product__size--active');

        const id = parseInt(btn.dataset.variantId);
        const variant = this.product.variants.find(v=>v.id===id);
        if(!variant) return;

        this.currentVariant = variant;
        this.variantInput.value = variant.id;
        this.priceEl.textContent=(variant.price/100).toFixed(2)+' €';

        if(variant.featured_image && variant.featured_image.src){
          this.mainImage.src = variant.featured_image.src;
        }

        this.selectedText.textContent = btn.dataset.size;
        this.atcBtn.disabled = false;
        this.atcBtn.textContent = "ADD TO CART";
      });
    });
  }

  bindGallery() {
    this.root.querySelectorAll('.p-product__thumb').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const img = btn.dataset.image;
        if(img) this.mainImage.src = img;
      });
    });
  }

  bindATC(){
    this.root.querySelector('[data-form]').addEventListener('submit',e=>{
      e.preventDefault();
      if(!this.currentVariant) return;

      this.atcBtn.disabled=true;
      this.atcBtn.textContent="ADDING...";

      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:this.currentVariant.id,quantity:1})
      })
      .then(res=>res.json())
      .then(()=>{this.openCartDrawer()})
      .catch(()=>{this.atcBtn.textContent="ERROR"});
    });
  }

  bindCartDrawer(){
    this.closeCartBtn?.addEventListener('click',()=>{this.closeCartDrawer()});
  }

  openCartDrawer(){
    this.cartDrawer.classList.add('cart-drawer--open');
    this.updateCartItems();
    this.atcBtn.textContent="✓ ADDED";
    setTimeout(()=>{this.atcBtn.textContent="ADD TO CART";this.atcBtn.disabled=false},1200);
  }

  closeCartDrawer(){
    this.cartDrawer.classList.remove('cart-drawer--open');
  }

  updateCartItems(){
    fetch('/cart.js')
      .then(res=>res.json())
      .then(cart=>{
        this.cartContent.innerHTML='';
        cart.items.forEach(item=>{
          const div=document.createElement('div');
          div.className='cart-drawer__item';
          div.innerHTML=`${item.quantity} × ${item.product_title}`;
          this.cartContent.appendChild(div);
        });
      });
  }
}

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-root]').forEach(el=>{
    new ProductElite(el);
  });
});